import { Wizard } from 'react-use-wizard'
import { Wrapper } from 'OnDemandActions/Sell/CodDateChange/shared/Styles'
import Step1 from 'OnDemandActions/Sell/CodDateChange/SignedAddendum/Steps/Step1'
import Step2 from 'OnDemandActions/Sell/CodDateChange/SignedAddendum/Steps/Step2'
import Step3 from 'OnDemandActions/Sell/CodDateChange/SignedAddendum/Steps/Step3'
import Step4 from 'OnDemandActions/Sell/CodDateChange/SignedAddendum/Steps/Step4'
import { useState } from 'react'

const SignedAddendum = ({ close = () => {}, coe = {}, es = {} }) => {
    const [data, setData] = useState({
        extendedStay: '',
        extendedStayDays: '',
    })

    return (
        <Wizard wrapper={<Wrapper />}>
            <Step1 data={data} setData={setData} coe={coe} es={es} />
            <Step2 data={data} setData={setData} coe={coe} es={es} />
            <Step3 data={data} setData={setData} coe={coe} es={es} />
            <Step4 data={data} setData={setData} coe={coe} es={es} close={close} />
        </Wizard>
    )
}

export default SignedAddendum
